import { Flex, Modal, Dropdown, Button } from "antd"
import { MoreOutlined, BranchesOutlined, CopyOutlined, DeleteOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"

const ConditionRow = ({ handleConditionClick, condition, handleConditionDelete, handleConditionCopy }) => {
    const { t } = useTranslation();
    const confirmConditionCopy = () => {
        Modal.confirm({
            title: t('Confirm'),
            content: t('Are you sure you want to copy the condition?'),
            okText: t("Yes"),
            cancelText: t("No"),
            onOk: (event) => {
                handleConditionCopy(condition)
                Modal.destroyAll()
            },
            footer: (_, { OkBtn, CancelBtn }) => (
                <>
                    <CancelBtn />
                    <OkBtn />
                </>
            ),
        });
    }

    const confirmConditionDelete = () => {
        Modal.confirm({
            title: t('Confirm'),
            content: t('Are you sure you want to delete the condition?'),
            okText: t("Yes"),
            cancelText: t("No"),
            onOk: (event) => {
                handleConditionDelete(condition.conditionId)
                Modal.destroyAll()
            },
            footer: (_, { OkBtn, CancelBtn }) => (
                <>
                    <CancelBtn />
                    <OkBtn />
                </>
            ),
        });
    }

    const conditionActions = [
        {
			key: "copy",
			label: <Flex gap={8} style={{width: "120px"}}><CopyOutlined /><span>{t("Copy")}</span></Flex>,
			onClick: confirmConditionCopy
		},
		{
			key: "delete",
			label: <Flex gap={8} style={{width: "120px"}}><DeleteOutlined /><span>{t("Delete")}</span></Flex>,
			danger: true,
			onClick: confirmConditionDelete
		},
    ]


    return (
        <Flex className='condition-group-row' justify="space-between" align="center" key={condition.conditionId} >
            <Flex gap={16} align="center" onClick={() => handleConditionClick(condition)}>
                <div className='icon-box'>
                    <BranchesOutlined style={{ color: "rgba(10, 153, 254, 1)" }} />
                </div>
                <div className='text-color-primary' style={{ lineHeight: "24px", textAlign: "left" }}>{condition.name}</div>
            </Flex>
            <Dropdown overlayClassName="user-account" trigger={"click"} menu={{ items: conditionActions }} placement="bottomRight">
                <Button icon={<MoreOutlined />} size="small"></Button>
            </Dropdown>
        </Flex>
    )
}

export default ConditionRow